import { render, staticRenderFns } from "./WorkDescription.vue?vue&type=template&id=c72abb4c&scoped=true&"
import script from "./WorkDescription.vue?vue&type=script&lang=js&"
export * from "./WorkDescription.vue?vue&type=script&lang=js&"
import style0 from "./WorkDescription.vue?vue&type=style&index=0&id=c72abb4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72abb4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
